/* eslint-disable no-throw-literal */
import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

/**
 * Should be removed when migrating to service-rfo
 */
export default class OldRfpApi {
  private rfpBuApi: ApiClient;

  private rfpProductApi: ApiClient;

  public constructor(options?: ApiClientOptions) {
    this.rfpBuApi = new ApiClient(getServiceUrl('buyingunit'), options);
    this.rfpProductApi = new ApiClient(getServiceUrl('product'), options);
  }

  public async getRfps(targetMarketId: number, filters: object) {
    const query = '/buyingunit/v3/rfps';
    if (!targetMarketId) {
      throw {
        message: 'Missing parameter: targetMarketId',
        name: 'bad parameter',
      };
    }
    const data = {
      target_market_id: targetMarketId,
      ...filters,
    };
    return this.rfpBuApi.get(query, qs.stringify(data, true), false);
  }

  public async getRfp(rfpId: number) {
    const query = `/buyingunit/v3/rfp/${rfpId}`;
    if (!rfpId) {
      throw {
        message: 'Missing parameter: rfpId',
        name: 'bad parameter',
      };
    }
    return this.rfpBuApi.get(query, '', false);
  }

  public async declineRfp(rfpId: number) {
    const query = '/product/v2/rfp/decline';
    if (!rfpId) {
      throw {
        message: 'Missing parameter: data',
        name: 'bad parameter',
      };
    }
    return this.rfpProductApi.post(query, { rfp_id: rfpId });
  }

  public async saveAnswer(data: object) {
    const query = '/product/v2/rfp/answers';
    if (!data) {
      throw {
        message: 'Missing parameter: data',
        name: 'bad parameter',
      };
    }
    return this.rfpProductApi.post(query, data);
  }

  public async sendAnswer(data: object) {
    const query = '/product/v2/rfp/answers/send';
    if (!data) {
      throw {
        message: 'Missing parameter: data',
        name: 'bad parameter',
      };
    }
    return this.rfpProductApi.post(query, data);
  }

  public async deleteAnswer(data: object) {
    const query = '/product/v2/rfp/answers/delete';
    if (!data) {
      throw {
        message: 'Missing parameter: data',
        name: 'bad parameter',
      };
    }
    return this.rfpProductApi.post(query, data);
  }
}
